const NOT_SELECTED = "not_selected";
const SUPPORTED_COUNTRIES = new Set(["US", "CA", "AU", "IN", "GB", "DE", "FR", "JP"]);

function normalizedCountry(value) {
  const country = typeof value === "string" ? value.trim().toUpperCase() : "";
  return SUPPORTED_COUNTRIES.has(country) ? country : NOT_SELECTED;
}

/**
 * Produce edition context for analytics. The public web intentionally sends
 * no city, coordinates, address, selected-location proof, or device-derived
 * location through either its direct Google tag or first-party fallback.
 */
export function resolveSelectedLocationAnalyticsContext(input = {}) {
  const authenticatedAccount = input.authenticatedAccount === true;
  const hasStoredPreferences = input.hasStoredPreferences === true;
  const usePreferences =
    hasStoredPreferences && (authenticatedAccount || input.firstRunCompleted === true);
  const countrySource =
    authenticatedAccount && !hasStoredPreferences
      ? undefined
      : usePreferences
        ? input.preferencesCountry
        : input.firstRunCountry;

  return {
    userProperties: {
      selected_country: normalizedCountry(countrySource),
    },
  };
}

export function resolveSelectedLocationUserProperties(input = {}) {
  return resolveSelectedLocationAnalyticsContext(input).userProperties;
}

export const SELECTED_LOCATION_NOT_SELECTED = NOT_SELECTED;
export const SELECTED_LOCATION_SUPPORTED_COUNTRIES = Object.freeze([...SUPPORTED_COUNTRIES]);
